import { format } from 'date-fns'

export function formatDateTime(local_start_date, local_start_time) {
  return format(
    Date.parse(`${local_start_date}T${local_start_time}`),
    'MM/dd/yyyy · hh:mm aa'
  )
}
